import { QueryConfig } from "store/utils/query-config";

export const checkListsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"],
  },
};
